import { Trash } from "lucide-react";
import { Button } from "@tellescope/ui";
import type { Drug } from "./useEligibilitySubmissionForm";

export interface SelectedDrugRowProps {
  drug: Drug;
  onRemove: (drug: Drug) => void;
}

export const SelectedDrugRow = ({ drug, onRemove }: SelectedDrugRowProps) => (
  <div className="flex items-center justify-between p-3 border rounded-lg">
    <div className="flex-1">
      <div className="font-medium">{drug.name}</div>
      <div className="flex items-center">
        <span className="text-sm text-foreground pr-2">{drug.dosage}</span>
        <span className="text-sm text-muted-foreground">{drug.quantity}</span>
      </div>
    </div>
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => onRemove(drug)}
      className="text-foreground hover:text-foreground size-9"
    >
      <Trash className="h-4 w-4" />
    </Button>
  </div>
);
